import React from 'react'
import { Box, Typography } from '@mui/material'
import { LaurelWreathLeft, LaurelWreathRight } from './icons'

const PaywallLaurelWreath = () => {
  return (
    <Box sx={{ minWidth: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 4 }}>
      <LaurelWreathLeft />
      <Typography sx={{ textAlign: 'center' }}>
        <strong>24 Million</strong> users <br /> across <strong>160</strong> countries
      </Typography>
      <LaurelWreathRight />
    </Box>
  )
}

export default PaywallLaurelWreath
